import CookieUtil from './util/cookieUtil';
import EnhancedSeo from './enhancedSeo';
import UrlParams from './util/urlParams';
import recentlyViewed from './widgets/recentlyViewed';
import {wishlistModal} from './components/wishlist';
import Seo from './components/seo.js';
import {initOwlCarousel} from './performance/owl';
import {initWishlist} from "./performance/wishlist";
import {getUnloadedScripts, promiseAllScripts} from "./performance/helpers/scriptLoader";

function attachShowMoreObserver(target, callback){
    if(target.length < 1)
        return;

    let jsTarget = target[0];
    if(jsTarget.classList && jsTarget.classList.contains('observed'))
        return;

    const observer = new IntersectionObserver(callback, {
        root: null,
        rootMargin: '0px',
        threshold: 0.5
    });

    observer.observe(jsTarget);
    jsTarget.classList.add('observed');
}

function enterView(entries, observer) {
    entries.forEach(function (entry) {
        if (entry.isIntersecting){
            entry.target.click();
            observer.unobserve(entry.target)
        }
    });
}


/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    const $updates = $results.find(selector);
    $(selector).html($updates.html());
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $('.refinement.active').each(function () {
        $(this).removeClass('active');

        $results.find(`.${$(this)[0].className.replace(/ /g, '.')}`).addClass('active');
    });

    updateDom($results, '.refinements');
    updateRefinementListeners('.refinement-bar');
}

/**
 * Remove and readd scroll event listener after Ajax refresh
 *
 * @param {String} selector - a CSS selector to find the target
 * @return {undefined}
 */
function updateRefinementListeners(selector = '.refinement-bar') {
    // Handle horizontal scroll on mobile filters
    const delta = 20;
    const $scrollable = $(selector).find('.mobile-filter-nav-wrapper .plp-sort-order');

    if ($scrollable.length) {
        // Always hide scrim if scrollable amount is less then the available width (with some delta)
        if ($scrollable.get(0).scrollWidth < $scrollable.get(0).clientWidth + delta / 4) {
            $scrollable.closest('.plp-header-top-sort').addClass('no-scrim');
        } else {
            // Add listener directly to target element, as scroll event does not bubble
            $scrollable.closest('.plp-header-top-sort').removeClass('no-scrim');
            $scrollable.off('scroll');
            $scrollable.on('scroll', (event) => {
                const $target = $(event.currentTarget);

                if ($target.scrollLeft() > delta) {
                    $target.closest('.plp-header-top-sort').addClass('scrolled');
                } else {
                    $target.closest('.plp-header-top-sort').removeClass('scrolled');
                }
            });
        }
    }
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handlePageTitle($results) {
    if ($results.find('[data-page-title]').length > 0) {
        var newPageTitleValue = $results.find('[data-page-title]').attr('data-page-title');

        $('[data-page-title]').attr('data-page-title', newPageTitleValue);
        $('title').text(newPageTitleValue);
    }
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    const $results = $(response);
    const specialHandlers = {
        '.refinements': handleRefinements,
        '[data-page-title]': handlePageTitle
    };

    ['.grid-header',
        '.header-bar',
        '.header.page-title',
        '.product-grid',
        '.show-more-previous',
        '.show-more',
        '.filter-bar',
        '.plp-header-bottom-sort-wrapper',
        '.plp-header-top-sort',
        '.info-box-element',
        '.show-for-breakpoint-tablet-extra-global-plp',
        '.labelCounts'
    ].forEach((selector) => {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach((selector) => {
        specialHandlers[selector]($results);
    });
}


function isElementInViewport(element) {
    const rect = element.getBoundingClientRect();
    return rect.top >= 0 && rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth);
}

class Plp {
    constructor() {
        this.bodyElement = 'body';
        this.container = '.container';
        this.filterSelectors = '.refinements li a, .refinement-bar a.reset, .filter-value a, .swatch-filter a';
        this.gridFooter = '.grid-footer';
        this.gridHeader = '.grid-content-header',
        this.htmlBody = 'html, body';
        this.interchangePlaceholder = '[data-interchange][src*=uninitialized]';
        this.pagCurrent = '.pagination .current';
        this.productGrid = '.product-grid';
    }

    run() {
        this.applyFilter();
        this.buttonGotoTop();
        this.closeRefinments();
        this.filter();
        this.paginationPlp();
        this.plpMobileMenu();
        // this.rellax();
        this.rowSwitch();
        this.showMore();
        this.sort();
        this.categoriesWidget();
        this.plpAccordionBehavior();
        EnhancedSeo.productColorClick(['.color-swatches', 'a', '[data-pid]', 'pid', 'data-family-color-search']);
        recentlyViewed.run();
        Seo.viewItemListGA4Event();

        this.goToPDP();
        initWishlist();

        this.initializePosition();
        this.handleGoBack();
    }

    handleGoBack(){
        window.addEventListener('popstate', function(event) {
            if($("body").hasClass('menu-visible') || window.location.href.endsWith('/#')){
                return
            }
            location.reload();
        });
    }

    initializePosition(){
        document.addEventListener('DOMContentLoaded', () => {
            history.scrollRestoration = 'manual';
        });

        window.onload = function(){
            let pid = window.history && window.history.state ? window.history.state.pid : false;
            if(!pid)
                return;

            let element = document.querySelector('.image-link[data-pid="' + pid + '"]');
            if(element && !isElementInViewport(element)){
                const rect = element.getBoundingClientRect();
                window.scrollTo({
                    top: window.pageYOffset + rect.top - 175,
                    behavior: 'smooth',
                    block: 'start'
                })
            }
        };
    }

    goToPDP(){
        $(document).on('click', '.image-link', (event) => {
            event.preventDefault();
            let elementPage = event.currentTarget.dataset ? event.currentTarget.dataset.page : false;
            let currentUrl = new URL(window.location.href);
            if(elementPage && elementPage !== 'null')
                currentUrl.searchParams.set('page', elementPage);

            history.scrollRestoration = 'manual';
            window.history.pushState({'pid' : event.currentTarget.dataset.pid}, '', currentUrl);

            window.location.href = event.currentTarget.href;
        });
    }

    plpAccordionBehavior(){
        $(document).on('click', '.open-plp-accordion', (event) => {
            $('.compact-plp-accordion').hide();
            $('.extended-plp-accordion').show();

            dataLayer.push({
                event: "GAevent",
                eventID: "001",
                eventCategory: "user_interaction",
                eventAction: "plp_insights",
                eventLabel: "read_more_open",
                eventElement01: "-",
                eventElement02: "-",
                eventElement03: "-"
            })
        });

        $(document).on('click', '.close-plp-accordion', (event) => {
            $('.compact-plp-accordion').show();
            $('.extended-plp-accordion').hide();

            dataLayer.push({
                event: "GAevent",
                eventID: "001",
                eventCategory: "user_interaction",
                eventAction: "plp_insights",
                eventLabel: "read_more_closed",
                eventElement01: "-",
                eventElement02: "-",
                eventElement03: "-"
            })
        });
    }

    ajaxRequestComplete() {
        this.lazyLoadImage();
        this.filterAccordion();
        wishlistModal();
    }

    buttonGotoTop() {
        $(document).on('click', '.button-goto-top', (event) => {
            event.preventDefault();
            this.goToTop();
        });
    }

    goToTop() {
        $(this.htmlBody).animate({
            scrollTop: 0
        }, 650, 'easeInOutCirc');
    }

    lazyLoadImage() {
        $(this.interchangePlaceholder).foundation();
    }

    rowSwitch() {
        $('.cta-layout-1').click(() => {
            $(this.bodyElement).removeClass('plp-two-row');
            window.localStorage.setItem('plpTwoRow', false);
            EnhancedSeo.layoutSmallViewPlp();
        });

        $('.cta-layout-2').click(() => {
            $(this.bodyElement).addClass('plp-two-row');
            window.localStorage.setItem('plpTwoRow', true);
            EnhancedSeo.layoutBigViewPlp();
        });

        let block = window.localStorage.getItem('plpTwoRow');

        if (block === 'true') {
            $(this.bodyElement).addClass('plp-two-row');
        }
    }

    filter() {
        $(this.container).on('click', 'button.filter-results', () => {
            $('.refinement-bar').css({display: 'flex'});
            updateRefinementListeners();
            $(this.bodyElement).addClass('mobile-filter-nav-visible');
            document.dispatchEvent(new Event('plp:afterRefinementBarOpen'));
        });

        this.filterAccordion();
        this.activeFilters();
    }

    filterAccordion() {
        if (['small', 'medium'].indexOf(Foundation.MediaQuery.current) > -1) return;

        $('.plp-header-content-card-body .toggle p').click((e) => {
            const current = $(e.currentTarget);
            const list = current.next('ul');

            if (list.is(':visible')) {
                current.removeClass('open');
                list.slideUp();
            } else {
                $('.plp-header-content-card-body .toggle p').removeClass('open');
                if ($('.plp-header-content-card-body .toggle ul').not(list).is(':visible')) {
                    $('.plp-header-content-card-body .toggle ul').not(list).slideUp(() => {
                        list.slideDown();
                        current.addClass('open');
                    });
                } else {
                    list.slideDown();
                    current.addClass('open');
                }
            }
        });
    }

    closeRefinments() {
        $(this.container).on('click', '.refinement-bar button.close', () => {
            $('.refinement-bar').hide();
            $(this.bodyElement).removeClass('mobile-filter-nav-visible');
            document.dispatchEvent(new Event('plp:afterRefinementBarClose'));
        });
    }

    sort() {
        $(this.container).on('click', '.plp-sort-order a', (event) => {
            event.preventDefault();
            $(event.currentTarget).parent().addClass('current').siblings()
                .removeClass('current');
            $(event.currentTarget).trigger('search:sort', event);
            $.ajax({
                url: event.target.href,
                data: {
                    selectedUrl: event.target.href
                },
                method: 'GET',
                success: (response) => {
                    $(this.productGrid).html(response);
                    parseResults(response);
                    this.ajaxRequestComplete();
                }
            });
        });

        updateRefinementListeners();
        $(window).on('resize', updateRefinementListeners);
    }

    sortOptionsUpdate() {
        const getSortOptions = $(this.gridFooter).data('sort-options');

        $(`.${getSortOptions.ruleId}`).addClass('current').siblings().removeClass('current');
    }

    updateSortOptions(response, isPrevious) {
        let sortOptions;
        if(isPrevious){
            sortOptions = $(document).find('.grid-footer').data('sort-options').options;
        }
        else {
            const $tempDom = $('<div>').append($(response));
            sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
        }

        sortOptions.forEach((option) => {
            $(`option.${option.id}`).val(option.url);
        });
    }

    showMore() {
        $(document).on('click', '.show-more button, .show-more-previous button', (event) => {
            event.preventDefault();

            EnhancedSeo.showMoreClick();

            const showMoreUrl = $(event.currentTarget).data('url');

            $(event.currentTarget).trigger('search:showMore', event);


            let isPrevious = event.currentTarget.classList.contains('js-previous');
            $.ajax({
                url: showMoreUrl,
                data: {
                    selectedUrl: showMoreUrl
                },
                method: 'GET',
                beforeSend: () => {
                    $(this.productGrid).addClass('loading');
                    $(this.gridFooter).addClass('loading');
                },
                success: (response) => {
                    const valueParam = new URLSearchParams(showMoreUrl);
                    let pageParam = valueParam.get("page");
                    if(pageParam && pageParam !== 'null'){
                        let currentUrl = new URL(window.location.href);
                        sessionStorage.setItem('pageNumber', pageParam);

                        currentUrl.searchParams.set('page', pageParam);
                        window.history.pushState({}, '', currentUrl);
                    }

                    if(isPrevious)
                        $(this.gridHeader).replaceWith(response);
                    else
                        $(this.gridFooter).replaceWith(response);

                    $(this.bodyElement).addClass('show-more-loaded');
                    $(this.productGrid).removeClass('loading');
                    $(this.gridFooter).removeClass('loading');
                    this.updateSortOptions(response, isPrevious);
                    this.ajaxRequestComplete();
                    var urlWithSize = JSON.parse($('.grid-footer').attr('data-sort-options'));
                    window.localStorage.setItem('page_size_url', urlWithSize.options[0].url);

                    if($('.extended-plp-accordion').css('display') !== 'none'){
                        $('.compact-plp-accordion').show();
                        $('.extended-plp-accordion').hide();
                    }

                    $(window).trigger('gtmAsyncTrack::impression');

                    attachShowMoreObserver($('.show-more button'), enterView);
                }
            });
        });
    }

    applyFilter() {
        $(this.container).on('click', this.filterSelectors, (event) => {
            event.preventDefault();

            var clickedFilter = $(event.currentTarget);

            if ($(event.currentTarget).hasClass('disabled')) {
                return false;
            }

            $(event.currentTarget).trigger('search:filter', event);

            if ($(event.currentTarget).hasClass('reset')) {
                window.localStorage.removeItem('category_filter');
            }

            $('body').addClass('filtering-products');

            if (event.currentTarget.dataset.type === 'category') {
                window.localStorage.setItem('category_filter', 'true');
            }

            var url = event.currentTarget.href;

            // TR-1864
            window.history.pushState({}, '', url);

            $.ajax({
                'url': url,
                data: {
                    // page: $(this.gridFooter).data('page-number'),
                    selectedUrl: event.currentTarget.href
                },
                method: 'GET',
                success: (response) => {
                    parseResults(response);
                    this.ajaxRequestComplete();

                    // this trigger is for datalayer update in seo.js
                    var refinements = $('div.refinements');
                    refinements.trigger('refinements:update', { clickedFilter: clickedFilter });

                    this.activeFilters();

                    // TR-1864
                    this.detoxUrl(url, refinements);

                    let currentFooter = $('.grid-footer');
                    let counterSpan = $('.plp-content-counter');
                    if(currentFooter.length > 0 && counterSpan.length > 0){
                        counterSpan[0].innerHTML = currentFooter.data('count');
                    }
                },
                complete: (jqXHR, textStatus) => {
                    $('body').removeClass('filtering-products');
                }
            });
        });
    }

    paginationPlp() {
        $(this.productGrid).on('click', '.pagination-item', (event) => {
            event.preventDefault();

            const $self = $(event.currentTarget).find('button');
            let pagenumber = parseInt($self.data('page-number'), 10);
            pagenumber = (Number.isNaN(pagenumber)) ? 1 : pagenumber;
            let searchKeywords = $self.data('searchkeywords') || '';

            let currentUrl = new URL(window.location.href);
            currentUrl.searchParams.set('page', pagenumber);
            if(searchKeywords && searchKeywords !== '')
                currentUrl.searchParams.set('q', searchKeywords);
            window.history.pushState({}, '', currentUrl);

            const paginationUrl = $self.data('url');
            if (!paginationUrl || $self.parent().hasClass('current')) {
                return;
            }

            EnhancedSeo.paginationEventClick($self, [$(event.currentTarget)[0], 'pagination-next', 'pagination-prev', 'data-page-number']);

            this.navigateToPage(paginationUrl);
        });
    }

    navigateToPage(paginationUrl) {
        $.ajax({
            url: paginationUrl,
            data: {
                selectedUrl: paginationUrl
            },
            beforeSend: () => {
                $(this.productGrid).addClass('loading');
            },
            method: 'GET',
            success: (response) => {
                $(this.productGrid).html(response).removeClass('loading');
                var resultsLabel = $('#resultsLabel').text()
                $('#labelElements').empty().text(resultsLabel);
                this.ajaxRequestComplete();
                this.goToTop();
                var currentPage = parseInt($('.plp-pagination .current').children().first().text(), 10);
                if (!isNaN(currentPage) && parseInt(currentPage, 10) > 1) {
                    if ($('.info-box').length > 0) {
                        if (!$('.info-box').parents('.grid-container').hasClass('hidden')) {
                            $('.info-box').parents('.grid-container').addClass('hidden');
                        }
                        if ($('.show-for-breakpoint-tablet-extra-global-plp').length > 0) {
                            if (!$('.show-for-breakpoint-tablet-extra-global-plp').hasClass('hidden')) {
                                $('.show-for-breakpoint-tablet-extra-global-plp').addClass('hidden');
                                $('.show-for-breakpoint-tablet-extra-global-plp').removeClass('show-for-breakpoint-tablet-extra-global-plp');
                            }
                        }
                    }
                } else if ($('.info-box').length > 0) {
                    $('.info-box').parents('.grid-container').removeClass('hidden');
                }
                $(window).trigger('gtmAsyncTrack::impression');
            }
        });
    }

    rellax(timeOut = 0) {
        if (!$('[data-rellax]').length || ['small', 'medium'].indexOf(Foundation.MediaQuery.current) > -1) return;

        $('[data-rellax]:not(.rellax-active)').each((i, el) => {
            $(el).addClass('rellax-active');
            setTimeout(() => {
                const rellax = new Rellax(el, {
                    center: $(el).data('rellax-center')
                });
            }, timeOut);
        });
    }

    plpMobileMenu() {
        if (['small', 'medium'].indexOf(Foundation.MediaQuery.current) === -1) return;

        $(this.container).on('click', '.plp-header-content-card-title', (event) => {
            event.preventDefault();

            const $this = $(event.currentTarget);

            if ($this.next().hasClass('show')) {
                $this.next().removeClass('show');
                $this.next().slideUp(350);
            } else {
                $this.parent().parent().find('.plp-header-content-card-body').removeClass('show');
                $this.parent().parent().find('.plp-header-content-card-body').slideUp(350);
                $this.next().toggleClass('show');
                $this.next().slideToggle(350);
            }
        });
    }

    categoriesWidget() {
        const itemsOnView = 4;
        const $sliderWrap = $('.categories-render');
        const $slider = $('.categories-row-render');
        const $itemsLenght = $('.category-cell-render').length;
        const total = Math.ceil($itemsLenght / itemsOnView);

        if ($itemsLenght <= itemsOnView) {
            $sliderWrap.find('.counters').hide();
        }

        //Lazyload owl carousel for quick view
        function owlInitialization(){
            $('.categories-row-render').owlCarousel({
                dots: false,
                responsiveClass: true,
                responsive: {
                    0: {
                        items: 2,
                        center: true,
                        margin: 20,
                        autoWidth: true
                    },
                    640: {
                        items: 3,
                        slideBy: 3,
                        margin: 20
                    },
                    1024: {
                        items: itemsOnView,
                        slideBy: itemsOnView,
                        margin: 40,
                        mouseDrag: !(($itemsLenght <= itemsOnView))
                    },
                    1600: {
                        items: itemsOnView,
                        slideBy: itemsOnView,
                        margin: 40,
                        mouseDrag: !(($itemsLenght <= itemsOnView))
                    }
                }
            })
        }
        initOwlCarousel(owlInitialization);


        $sliderWrap.find('.total').text(total);

        $sliderWrap.on('click', '.prev', (event) => {
            $sliderWrap.find('.owl-prev').trigger('click');
        });

        $sliderWrap.on('click', '.next', (event) => {
            $sliderWrap.find('.owl-next').trigger('click');
        });

        $slider.on('changed.owl.carousel', (e) => {
            const lastIndex = e.item.index + (itemsOnView - 1);
            const init = Math.floor(lastIndex / itemsOnView);
            const test = init * itemsOnView;
            const final = (lastIndex >= test) ? init + 1 : null;

            $sliderWrap.find('.current').text(final);
        });
    }

    activeFilters() {
        const refinements = $('.plp-header-content .refinement:not(.hide)');
        ['.plp-hero-with-filters .filters .button-text',
            '.plp-header-top .refinement:not(.hide) .plp-header-content-card-title'
        ].forEach((selector) => {
            const texts = $(selector);
            const length = Math.min(texts.length, refinements.length);
            for (let index = 0; index < length; index++) {
                let text = $(texts[index]).contents().get(0);
                let selected = $(refinements[index]).find('.selected');
                text.nodeValue = $.trim(text.nodeValue).replace(/\s+\(\d+\)$/, '') + (selected.length ? (' (' + selected.length + ')') : '');
            }
        });

        const results = $('.plp-header-top .filter-results');
        const text2 = results.contents().get(0);
        const selected2 = $('.plp-header-top .refinement:not(.hide) .selected');
        text2 && (text2.nodeValue = (results.data(selected2.length ? 'msgFiltersN' : 'msgButtonFilter') || '').replace('{0}', '' + selected2.length));
    }

    detoxUrl(url, refinements) {
        var url2 = url;
        refinements.find('a.disabled[role="button"]').each(function () {
            var id = $(this).data('id');
            var matches = url2.match(new RegExp(`[?&]prefn(\\d+)=${id}&`));
            if (!matches) return;
            var number = matches[1];
            var value = encodeURIComponent($.trim($('span.disabled', this).contents().get(0).nodeValue));
            var separator = encodeURIComponent('|');
            // console.log('id', id, 'number', number, 'value', value, 'separator', separator);
            url2 = url2.replace(new RegExp(`(&prefv${number}=)([^&]*)`), function (match, p1, p2) {
                var values = p2.split(separator);
                var index = values.indexOf(value);
                (index !== -1) && values.splice(index, 1);
                var replacement = `${p1}${values.join(separator)}`;
                // console.log('p2', p2, 'index', index, 'values', values, 'replacement', replacement);
                return replacement;
            });
            // console.log('url2', url2);
        });
        (url2 !== url) && window.history.pushState({}, '', url2);
    }

}

const plp = new Plp();
plp.run();



// WEBPACK FOOTER //
// ./assets/scripts/plp.js